<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row dense>
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaTerminais(empresaSelecionada)"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12">
        <v-data-table
          :search="tabela.busca"    
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
        >
          <template v-slot:[`item.status`]="{ item }">
            <v-icon :color="item.ativo ? 'green' : 'red'">mdi-circle</v-icon>
          </template>
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">TERMINAIS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoTerminal = true" tile color="#2C2E83" :disabled="user.tipo == 'ADMIN' ? empresaSelecionada == '' : false">
                <v-icon left dark>add_circle</v-icon>Adicionar Terminal
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn icon @click="editItem(item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon @click="deleteItem(item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.totemId`]="{ item }">
            <td>{{ nomeTotem(item.totemId) }}</td>
          </template>
        </v-data-table>
      </v-col>

      <v-dialog v-model="dialogoTerminal" persistent max-width="400px">
        <v-card>
          <v-card-title>{{ formTitleProd }}</v-card-title>
          <v-card-subtitle>*O preenchimento de todos os campos é obrigatório</v-card-subtitle>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-text-field v-model="terminal.nome" outlined label="Descrição" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="terminal.mac" v-mask="'XX:XX:XX:XX:XX:XX'" outlined label="Endereço MAC" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-autocomplete v-model="terminal.totemId" outlined label="Totem" color="#94AAB4" hide-details dense :items="totens" item-text="descricao" item-value="id"></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-switch
                  style="margin-top: 5px"
                  v-model="terminal.ativo"
                  label="ATIVO"
                  color="#00253E"
                  hide-details
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="salvarTerminal">Salvar</v-btn>
            <v-btn text color="red" @click="dialogoTerminal = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: {Snackbar},
    data: () => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      menu2: false,
      search: '',
      addUser: false,
      cadastroCategoria: false,
      dialogoTerminal: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', value: 'nome' },
          { text: 'Endereço MAC', value: 'mac' },
          { text: 'Totem', value: 'totemId' },
          { text: 'Status', value: 'status' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        carregamento: false,
        conteudo: [],
      },
      empresaSelecionada: '',
      empresas: [],
      editedIndex: -1,
      terminal: {
        descricao: "",
        mac: "",
        ativo: true,
        empresaId: "",
        totemId: "",
      },
      terminalDefault: {
        descricao: "",
        mac: "",
        ativo: true,
        empresaId: "",
        totemId: "",
      },
      totens: [],
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitleProd () {
        return this.editedIndex === -1 ? 'Adicionar novo terminal' : 'Editar terminal'
      },  
    }),

    watch: {
      dialogoTerminal(val) {
        if (val == false) {
          setTimeout(() => {
            this.terminal = Object.assign({}, this.terminalDefault)
            this.editedIndex = -1
          }, 300)
        }
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaTerminais(this.companyobj.id)
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaTerminais(empresaId) {
        this.tabela.carregamento = true
        this.tabela.conteudo = []

        await axios.get(baseApiUrl + 'Terminals?filter={"where":{"empresaId":"' + empresaId + '"}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          this.tabela.conteudo = response.data
          this.tabela.carregamento = false
        })

        this.carregaTotens(empresaId)
      },

      async carregaTotens(empresaId) {
        await axios.get(baseApiUrl + 'Totens?filter={"where":{"empresaId":"' + empresaId +'"}, "fields":{"descricao": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.totens = response.data
          }
        })
      },

      editItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.terminal = Object.assign({}, item)
        this.dialogoTerminal = true
      },

      async deleteItem(item) {
        let vm = this
        var r = confirm('Deseja realmente excluir o terminal: ' + item.descricao + '?')
        if (r == true) {
          await axios.delete(baseApiUrl + 'Terminals/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            this.carregaTerminais(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id)
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
        }
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      async salvarTerminal() {
        var vm = this

        if (this.terminal.descricao || this.terminal.mac || this.terminal.ativo || this.terminal.totemId) {
          this.terminal.empresaId = this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id
          if (!this.terminal.situacao) {
            this.terminal.situacao = 'LIVRE'
          }
          await axios.post(baseApiUrl + 'Terminals/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.terminal)
          .then(response => {
            if (response.data) {
              this.dialogoTerminal = false
              this.carregaTerminais(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id)
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos!", "ATENÇÃO")
        }
      },

      nomeTotem(totemId) {
        let nomeTotem

        this.totens.filter(totem => {
          if (totem.id === totemId) {
            nomeTotem = totem.descricao
          }
        })

        return nomeTotem
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }
</style>
